export const Bio = {
  name: "Ashwin  T",
  roles: [
    "Front-End Developer",
    "Web-Developer",
    "Programmer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Ashn20",
  resume:
    "https://drive.google.com/file/d/1Kg2DpaPpqxzkwRUvZvIXQ6eWInN5Fu1H/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/ashn20/",
  insta: "https://www.instagram.com/__.as.h.win.__?igsh=MTBxdjJ4ejEyaXpuNQ%3D%3D&utm_source=qr",
  facebook: "https://www.facebook.com/ashwin.lesnar.7",
};

export const skills = [
  {
    title: "Front-End",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "jQuery",
        image:
          "https://w7.pngwing.com/pngs/662/163/png-transparent-jquery-logo-web-development-jquery-ui-javascript-computer-icons-jqlogo-emblem-label-text-thumbnail.png",
      },
    ],
  },
  {
    title: "Back-End",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Django",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },


  {
    title: "Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://shorturl.at/duyEO",
    role: "Frontend Engineer Intern",
    company: "Shenchola Technology Solutions",
    date: "September 2023 - Pursuing",
    desc: " I delved deep into the World of HTML, CSS, JavaScript, React Js, jQuery and FrameWorks like CSS BootStrap & React Js BootStrap to craft dynamic and visually stunning User Interfaces. Delivered 15+ Simple yet elegant Front-End projects on GitHub showcasing a diverse range of skills.",
    skills: [
      "React JS",
      "Redux",

      "Material UI",
      "HTML",
      "CSS",
      "BootStrap",
      "JavaScript"
    ],
    doc: "",
  },

];

export const education = [
  {
    id: 0,
    img: "https://mce.edu.in/wp-content/uploads/2019/12/logo-150x150.png",
    school: "Meenakshi College of Engineering , Chennai",
    date: "August 2018 - Sep 2022",
    grade: "8.0 CGPA",
    desc: "I Completed my Bachelor's degree in Computer Science and Engineering at Meenakshi Collage of Engineering, Chennai. I have completed all semesters and ,I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Engineering - BE, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXz4HrDazygY5hzcVczHIBs5CCcg0jyHY3CB2q5OnxzOWu2wH4DAdwrewoYnwfkcH8c5c&usqp=CAU",
    school: "SRM Institute of Techology",
    date: "September 2023 - 2025 [Pursuing]",
    desc: "Pursuing my Online MCA in SRM kattankulathur",
    degree: "Master of Computer Applications",
  },
  {
    id: 2,
    img: "https://yt3.googleusercontent.com/ytc/APkrFKbij6TbfdYj_WCoLyusEQMI14jbvnKBWp9jXInc=s900-c-k-c0x00ffffff-no-rj",
    school: "Anita Methodist Matriculation Higher Seconday School, Chennai",
    date: "June 2016 - Apr 2018",
    grade: "70%",
    desc: "I Completed my class 12 high school education at Anita Methodist Matriculation Higher Seconday School",
    degree: "HSC (XII), Science with Computer",
  },
  {
    id: 3,
    img: "https://yt3.googleusercontent.com/ytc/APkrFKbij6TbfdYj_WCoLyusEQMI14jbvnKBWp9jXInc=s900-c-k-c0x00ffffff-no-rj",
    school: "Anita Methodist Matriculation Higher Seconday School, Chennai",
    date: "June 2015 - Apr 2016",
    grade: "80%",
    desc: "I Completed my class 12 high school education at Anita Methodist Matriculation Higher Seconday School",
    degree: "SSLC (X)",
  },

];

export const projects = [
  {
    id: 11,
    title: "P1",
    description:
      "This is just a Simple Web Page using only HTML",
    image:
      "https://i.ibb.co/H7Jxh7r/P1.png",
    tags: [
      "HTML & CSS",
    ],
    category: "web app",
    github: "https://github.com/Ashn20/P1",
    webapp: "https://ashn20.github.io/P1/",
  },
  {
    id: 9,
    title: "MARS",
    description:
      "Simple website of Mars and Earth using HTML & CSS",
    image:
      "https://i.ibb.co/g7VsYVb/Mars.png",
    tags: [
      "HTML & CSS",
    ],
    category: "web app",
    github: "https://github.com/Ashn20/Mars",
    webapp: "https://ashn20.github.io/Mars/",
  },
  {
    id: 0,
    title: "Profile-Card",

    description:
      "Profile-Card using HTML & CSS",
    image:
      "https://i.ibb.co/Xy83T7X/profile-card.png",
    tags: ["HTML & CSS",],
    category: "web app",
    github: "https://github.com/Ashn20/Profile-card",
    webapp: "https://ashn20.github.io/Profile-card/",

  },
  {
    id: 1,
    title: "Meta World-BootStrap",
    description:
      "Webpage for an Meta World Product using BootStrap",
    image:
      "https://i.ibb.co/71z0CVP/bootstrap.png",
    tags: [
      "HTML & CSS",
      "BootStrap",

    ],
    category: "web app",
    github: "https://github.com/Ashn20/BootStrap---Internship",
    webapp: "https://ashn20.github.io/BootStrap---Internship/",
  },
  {
    id: 2,
    title: "Form-Validation",

    description:
      "Form-Validation using React Js",
    image:
      "https://i.ibb.co/Ny5K58F/Form-Validation.png",
    tags: ["React Js"],
    category: "machine learning",
    github: "https://github.com/Ashn20/Form-Validation---React-Js",
    webapp: "https://ashn20.github.io/Form-Validation---React-Js/",

  },
  {
    id: 3,
    title: "QR Code Generator",
    description:
      "QR Code Generator Using JavaScript",
    image:
      "https://i.ibb.co/YhmKs66/QR-code.png",
    tags: ["JAVASCRIPT"],
    category: "android app",
    github: "https://github.com/Ashn20/QR-Code-Generator",
    webapp: "https://ashn20.github.io/QR-Code-Generator/",
  },
  {
    id: 10,
    title: "Hex Color Generator",
    description:
      "A Hex Color Generator Using JavaScript.",
    image:
      "https://i.ibb.co/23Kc6Qw/Hex-color.png",
    tags: ["JAVASCRIPT",],
    category: "android app",
    github: "https://github.com/Ashn20/Hex-Color-Generator---JavaScript",
    webapp: "https://ashn20.github.io/Hex-Color-Generator---JavaScript/",
  },
  {
    id: 12,
    title: "Login Form and Todo List",
    description:
      "Login Form and Todo List Created Using JavaScript",
    image:
      "https://i.ibb.co/XZPvDHC/Todo-list.png",
    tags: ["JAVASCRIPT",],
    category: "android app",
    github: "https://github.com/Ashn20/Login-Form---Todo-List-JavaScript-",
    webapp: "https://ashn20.github.io/Login-Form---Todo-List-JavaScript-/",
  },
  {
    id: 13,
    title: "Dice Game",
    description:
      "Dice Game created Using JavaScript",
    image:
      "https://i.ibb.co/R7QPRjw/Dice-game.png",
    tags: ["JAVASCRIPT",],
    category: "android app",
    github: "https://github.com/Ashn20/Dice-Game---JavaScript",
    webapp: "https://ashn20.github.io/Dice-Game---JavaScript/",
  },
  {
    id: 14,
    title: "Password Strength",
    description:
      "Password Strength Checker Using JavaScript",
    image:
      "https://i.ibb.co/RjXv292/password-strength.png",
    tags: ["JAVASCRIPT",],
    category: "android app",
    github: "https://github.com/Ashn20/Password-Strength-Checker",
    webapp: "https://ashn20.github.io/Password-Strength-Checker/",
  },
  {
    id: 15,
    title: "API Fetch",
    description:
      "JavaScript API Fetch with Home , Sign Up and Login Page",
    image:
      "https://i.ibb.co/tMvypzt/Api-fetch.png",
    tags: ["JAVASCRIPT",],
    category: "android app",
    github: "https://github.com/Ashn20/JavaScript---API-Fetch",
    webapp: "https://ashn20.github.io/JavaScript---API-Fetch/",
  },





  {
    id: 7,
    title: "Random Password Generator",

    description:
      "Random Password Generator Created using JavaScript",
    image:
      "https://i.ibb.co/9YttqDr/random-pass.png",
    tags: ["JAVASCRIPT"],
    category: "android app",
    github: "https://github.com/Ashn20/Random-Password-Generator",
    webapp: "https://ashn20.github.io/Random-Password-Generator/",
  },
  {
    id: 8,
    title: "Furniture website Landing Page",
    description:
      "A Simple Furniture website Landing Page using React Js",
    image:
      "https://i.ibb.co/cCf8MQM/landing-page-react.png",
    tags: ["React Js"],
    category: "machine learning",
    github: "https://github.com/Ashn20/React-Landing-Page",
    webapp: "https://ashn20.github.io/React-Landing-Page/",
  },
  {
    id: 6,
    title: "React Js - BootStrap",
    description:
      "A Simple Web Page using React Js - BootStrap",
    image:
      "https://i.ibb.co/dpTPTxJ/React-Bootstrap.png",
    tags: ["React Js"],
    category: "machine learning",
    github: "https://github.com/Ashn20/React---BootStrap",
    webapp: "https://ashn20.github.io/React---BootStrap/",
  },
  {
    id: 7,
    title: "React Js -API Fetch",
    description:
      "A Simple Web Page using API Fetch - React Js ",
    image:
      "https://i.ibb.co/ZKgvq4s/API-fetch-React.png",
    tags: ["React Js"],
    category: "machine learning",
    github: "https://github.com/Ashn20/React---Api-Fetch",
    webapp: "https://ashn20.github.io/React---Api-Fetch/",
  },
  
];

